const accordions = document.querySelectorAll('[data-accordion]')

function setHeightAndOpacity(content) {
    const fullHeight = content.scrollHeight;
    content.style.height = `${fullHeight}px`;
    content.style.opacity = '1';
}

accordions.forEach(accordion => {
    const toggler = accordion.querySelector('[data-accordion-toggler]');
    const toggleIcons = toggler.querySelector('.toggler-icons');
    const accordionContent = accordion.querySelector('[data-accordion-content]');
    let isTransitioning = false;

    toggler.addEventListener('click', () => {
        if (isTransitioning) {
            return;
        }

        // Close accordions
        accordions.forEach(siblingAccordion => {
            if (siblingAccordion !== accordion) {
                const siblingContent = siblingAccordion.querySelector('[data-accordion-content]');
                const siblingToggler = siblingAccordion.querySelector('[data-accordion-toggler]');
                const siblingToggleIcons = siblingToggler.querySelector('.toggler-icons');

                if (!siblingContent.classList.contains('hidden')) {

                    siblingToggleIcons.classList.add('closed');
                    siblingToggler.classList.remove('accordion-active');
                    siblingToggleIcons.classList.remove('opened');
                    siblingContent.style.height = '0px';
                    siblingContent.style.opacity = '0';
                }
            }
        });

        // Check current state 
        const isCurrentlyOpen = !accordionContent.classList.contains('hidden') &&
            getComputedStyle(accordionContent).height !== '0px';

        if (!isCurrentlyOpen) {
            toggleIcons.classList.remove('closed');
            toggleIcons.classList.add('opened');
            toggler.classList.add('accordion-active');
            accordionContent.classList.remove('hidden');
            accordionContent.setAttribute('aria-hidden', 'false');
            toggler.setAttribute('aria-expanded', 'true');

            setHeightAndOpacity(accordionContent);
        } else {
            toggleIcons.classList.add('closed');
            toggleIcons.classList.remove('opened');
            toggler.classList.remove('accordion-active');
            accordionContent.style.height = `${accordionContent.scrollHeight}px`;
            setTimeout(() => {
                accordionContent.style.height = '0px';
                accordionContent.style.opacity = '0';
            }, 125);
        }

        isTransitioning = true;

        setTimeout(() => {
            isTransitioning = false;
        }, 500);
    });

    accordionContent.addEventListener('transitionend', e => {
        if (e.propertyName !== 'height') return;

        isTransitioning = false;

        const isNowOpen = !accordionContent.classList.contains('hidden') &&
            getComputedStyle(accordionContent).height !== '0px';

        if (isNowOpen) {
            accordionContent.style.removeProperty('height');
            accordionContent.style.removeProperty('opacity');
        } else {
            accordionContent.classList.add('hidden');
            accordionContent.setAttribute('aria-hidden', 'true');
            toggler.setAttribute('aria-expanded', 'false');
            accordionContent.removeAttribute('style');
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const hash = window.location.hash.substring(1);

    if (hash) {
        const accordion = document.getElementById(hash);

        if (accordion && accordion.classList.contains('accordion')) {
            const toggler = accordion.querySelector('[data-accordion-toggler]');

            if (toggler) {
                toggler.click();
                accordion.scrollTo({ behavior: 'smooth' });
            }
        }
    }
});